import { FC, useState } from "react";
import Modal from "components/Modal";
import { CreateWheelRaffleForm } from "features/create-wheel-raffle";
import {
  RaffleSearchInput,
  useRaffleSearch,
} from "features/search-wheel-raffle";
import { Tabs } from "shared/ui";
import { GiftIcon } from "shared/ui/icons";
import { getRaffleTabs } from "../model/raffleTabs";
import type { RaffleTab } from "../model/raffleTabs";
import { useCanManageRaffles } from "../model/useCanManageRaffles";
import { useOpenRafflePage } from "../model/useRaffleNavigation";
import { RafflesBoard } from "./board/RafflesBoard";
import { RaffleHistory } from "./history/RaffleHistory";

import styles from "./WheelRafflesModal.module.css";

interface Props {
  initialTab: RaffleTab;
  onClose: () => void;
}

export const WheelRafflesModal: FC<Props> = ({ initialTab, onClose }) => {
  const canCreate = useCanManageRaffles();
  const [tab, setTab] = useState<RaffleTab>(initialTab);
  const search = useRaffleSearch();
  const openRafflePage = useOpenRafflePage();

  // Клик по табу выводит из поиска, иначе на Promos он ничего бы не менял.
  const onTabChange = (next: RaffleTab) => {
    if (search.isActive) search.clear();
    setTab(next);
  };

  return (
    <Modal
      isOpen
      onClose={onClose}
      iconNode={<GiftIcon width={20} height={20} />}
      title="Promos"
      className={styles.modal}
    >
      <div className={styles.content}>
        <p className={styles.subtitle}>
          Join promos, spin the wheel and win real rewards
        </p>
        <div className={styles.toolbar}>
          <Tabs
            items={getRaffleTabs(canCreate)}
            // Результаты поиска — и открытые, и из истории: таб не подсвечиваем.
            active={search.isActive ? null : tab}
            onChange={onTabChange}
            tabClassName={styles.tab}
            activeClassName={styles.activeTab}
          />
          {tab === "raffles" && (
            <div className={styles.search}>
              <RaffleSearchInput search={search} />
            </div>
          )}
        </div>
        {tab === "raffles" && (
          <RafflesBoard
            search={search}
            onOpenRaffle={(id, code) => openRafflePage(id, code, "raffles")}
          />
        )}
        {tab === "history" && (
          <RaffleHistory
            onOpenRaffle={(id) => openRafflePage(id, null, "history")}
          />
        )}
        {tab === "create" && (
          // После создания — сразу страница розыгрыша с таймером и участниками.
          <CreateWheelRaffleForm
            onCreated={(raffle) => openRafflePage(raffle.id, null, "raffles")}
          />
        )}
      </div>
    </Modal>
  );
};
